/* eslint-disable no-restricted-globals */
/* eslint-disable max-len */
import { saveConfiguration, updateChoiceSuccess } from '@gcc/configurator';
import alertModal from '@gcc/pip-components/dist/AlertModal';
import _filter from 'lodash/filter';
import _forEach from 'lodash/forEach';
import _get from 'lodash/get';
import _includes from 'lodash/includes';
import _values from 'lodash/values';
import _isEmpty from 'lodash/isEmpty';
import { area } from '../components/configurator/shapes/util';
import shapeMetadata from '../components/configurator/shapes/index';
import { getConfig } from '../config';

import {
  INVALID_SHAPE,
  SAVE_SHAPES_STARTED,
  SAVE_SHAPES_FINISHED,
  SAVE_SHAPES_FAILED,
  UPDATE_TOTAL_EXTERIOR_CORNERS,
  LOAD_SHAPE_INFO_FROM_CONFIGURATION,
  UPDATE_TOTAL_INTERIOR_CORNERS,
  PERSISTED_SHAPE_INFO,
  LOADED_PERSISTED_SHAPE,
  UPDATE_INITIAL_LOAD,
} from './actionTypes';
import { LAMINATE_PRODUCT_ID } from '../common/constants';
import { enableSave, disableSave } from './saveActions';
import { Utils, POST_FORM_TESTING_PARAM } from '../utils/urlUtils';
import { classifyShapes, classifyDesign } from '../utils/postform/designRules';

// const designBuilderApiBaseUrl = 'http://designbuilder.localtest.me';
export const saveShapes = (omsId, shapes) => (dispatch, getState) => {
  const prevArea = Math.round(getState().draftingTool.shapes.map((xx) => xx.area).reduce((aa, bb) => aa + bb, 0));
  const config = getConfig();
  const laminatePostFormFeatureGate = config?.laminatePostFormFeatureGate || Utils.getParameterByName(POST_FORM_TESTING_PARAM) === 'true';
  const productId = config?.productId;
  const isPostFormLaminate = Number(productId) === LAMINATE_PRODUCT_ID && laminatePostFormFeatureGate;

  dispatch({
    type: SAVE_SHAPES_STARTED,
  });

  // TODO: we will need to replace this with an appropriate API.
  // axios(url, { method: 'POST', data: shapeData })
  new Promise((resolve) => setTimeout(() => resolve(shapes)))
    .then(() => {
      let totalCtArea = 0;
      let areaChanged = false;
      for (let i = 0, len = shapes.length; i < len; i += 1) {
        const shape = shapes[i];
        const meta = shapeMetadata[shape.type];
        const poly = meta.toPolygon(shape);
        const shapeCtArea = area(poly);
        totalCtArea += Math.round(shapeCtArea) / 144;
        if (totalCtArea !== prevArea) {
          areaChanged = true;
        }
      }
      const designClassification = isPostFormLaminate ? classifyDesign(shapes) : 'none';
      dispatch({
        type: SAVE_SHAPES_FINISHED,
        payload: {
          shapes,
          areaChanged,
          designClassification,
        },
      });
    })
    .catch((error) => dispatch({
      type: SAVE_SHAPES_FAILED,
      payload: { error },
    }));
};

export const invalidShape = (invalidShapes) => (dispatch) => {
  const messages = {};
  invalidShapes.forEach((i) => {
    messages[i.shapeId] = i.messages;
  });
  dispatch({
    type: INVALID_SHAPE,
    isValid: !invalidShapes.length,
    messages,
  });

  if (!invalidShapes.length) {
    dispatch(enableSave());
  } else {
    dispatch(disableSave());
  }
};
export const updateInitialLoad = (initialLoad) => (dispatch, getState) => {
  dispatch({
    type: UPDATE_INITIAL_LOAD,
    payload: { initialLoad },
  });
};
export const updateTotalExteriorCorners = (totalExteriorCorners) => ({
  type: UPDATE_TOTAL_EXTERIOR_CORNERS,
  payload: totalExteriorCorners,
});

export const updateTotalInteriorCorners = (totalInteriorCorners) => (dispatch, getState) => {
  const { configurator } = getState();
  const InteriorCornerOptions = _filter(configurator.options, (opt) => _includes(opt.internalName, 'Interior_Corners'));
  let interiorCornerChoiceIds = [];
  _forEach(InteriorCornerOptions, (opt) => {
    interiorCornerChoiceIds = [...interiorCornerChoiceIds, ...opt.choices];
  });
  const interiorCornerChoices = _filter(configurator.choices, (ch) => _includes(interiorCornerChoiceIds, ch.id));
  const totalPreviousInteriorCorners = _filter(interiorCornerChoices, 'isSelected')
    .reduce((acc, curr) => ({ value: Number(acc.value) + Number(curr.value) }), { value: 0 }).value;

  if (totalInteriorCorners === 0 && totalPreviousInteriorCorners > 0) {
    _forEach(_filter(interiorCornerChoices, (ch) => ch.value === '0' || ch.value === ''), (choiceOfZero) => {
      dispatch(updateChoiceSuccess(choiceOfZero.optionId, choiceOfZero.id, choiceOfZero.value));
    });
  }

  dispatch({
    type: UPDATE_TOTAL_INTERIOR_CORNERS,
    payload: totalInteriorCorners,
  });
};

export const checkShapesAndSaveConfiguration = () => (dispatch, getState) => {
  const { isValid, messages } = getState().draftingTool;
  if (isValid) {
    dispatch(saveConfiguration());
  } else {
    const msg = [];
    _values(messages).forEach((mm) => msg.push(mm));
    alertModal({
      title: 'Please fix these problems before continuing',
      message: msg.join(),
      buttonLabel: 'Ok',
      width: '750px',
    });
  }
};

const handleDepricatedShapes = (prevDraftingTool) => {
  const shapes = prevDraftingTool.shapes.map((shape) => {
    switch (shape.type) {
    case 'island':
      return {
        ...shape,
        type: 'rectangle',
        edges: {
          ...shape.edges,
          cc: { ...shape.edges.a },
          dd: { ...shape.edges.b },
        },
      };
    case 'galley':
      return {
        ...shape,
        type: 'rectangle',
      };
    default:
      return shape;
    }
  });

  return { ...prevDraftingTool, shapes };
};

const getEnvBaseRedirect = () => {
  const env = getConfig()?.env;
  return Utils.containsNucleusPath()
    ? `${env.protocol}//${env.hostname}/render-nucleus`
    : `${env.protocol}//${env.hostname}:${env.port}/custom-countertops`;
};

export const loadPersistedShapes = (omsId) => (dispatch, getState) => {
  const env = getConfig()?.env;
  const { persistedShapeInfo } = getState();
  if (persistedShapeInfo.isLoadedPersistedShape === false) {
    const shapes = [];
    Object.keys(persistedShapeInfo).forEach((key) => {
      if (key > -1) {
        shapes.push(persistedShapeInfo[key]);
      }
    });
    dispatch(saveShapes(omsId, classifyShapes(shapes)));
    dispatch({
      type: LOADED_PERSISTED_SHAPE,
    });
  }

  const queryParams = new URLSearchParams((typeof window !== 'undefined') ? window.location.search : '');
  if (queryParams.get('persistedShapeInfo')) {
    const stateObj = { persistedShapeInfo: 'true' };
    const envBaseRedirect = getEnvBaseRedirect();
    let urlRewrite = '';
    if (Utils.containsNucleusPath()) {
      urlRewrite = `${envBaseRedirect}/countertops/configurator/${omsId}${Utils.deleteQueryParam(env.search, 'persistedShapeInfo')}`;
    } else {
      urlRewrite = `${envBaseRedirect}/countertops/configurator/${omsId}`;
    }
    if (typeof window !== 'undefined') {
      window.history.replaceState(stateObj, '', urlRewrite);
    }
  }
};

export const persistedShapeInfo = (newShapes) => (dispatch, getState) => {
  const state = getState();
  const stateObj = { persistedShapeInfo: 'true' };
  if (typeof window !== 'undefined') {
    window.history.replaceState(stateObj, '');
  }
  let shapes = {};
  if (newShapes) {
    shapes = classifyShapes(newShapes);
  } else {
    shapes = state.draftingTool.shapes;
  }
  dispatch({
    type: PERSISTED_SHAPE_INFO,
    payload: { shapes },
  });
};

const loadShapeInfoFromConfiguration = (prevDraftingTool) => (dispatch) => {
  let draftingTool = handleDepricatedShapes(prevDraftingTool);
  const config = getConfig();
  const laminatePostFormFeatureGate = config?.laminatePostFormFeatureGate || Utils.getParameterByName(POST_FORM_TESTING_PARAM) === 'true';
  const productId = config?.productId;
  const isPostFormLaminate = Number(productId) === LAMINATE_PRODUCT_ID && laminatePostFormFeatureGate;

  if (isPostFormLaminate) {
    if (!draftingTool.designClassification ||
        draftingTool.designClassification === 'none' ||
        draftingTool.designClassification === undefined) {
      const classifiedShapes = classifyShapes(draftingTool.shapes || [], productId);
      draftingTool = {
        ...draftingTool,
        shapes: classifiedShapes,
        designClassification: classifyDesign(classifiedShapes),
      };
    }
  } else {
    draftingTool = {
      ...draftingTool,
      designClassification: 'none',
    };
  }
  dispatch({
    type: LOAD_SHAPE_INFO_FROM_CONFIGURATION,
    payload: { draftingTool },
  });
};

export const loadShapes = () => (dispatch, getState) => new Promise((resolve) => {
  const state = getState();

  if (Utils.hasPlaGuid() && !Utils.hasItemInUrl()) {
    const { additionalDetails } = state?.plaConfiguration?.plaConfigurationDetails?.configuration;
    if (additionalDetails) {
      dispatch(loadShapeInfoFromConfiguration(JSON.parse(additionalDetails)));
    }
  } else {

    const { additionalDetails } = state?.configurator?.productInfo;
    const { draftingTool } = state;
    if (additionalDetails && draftingTool?.initialLoad) {
      dispatch(loadShapeInfoFromConfiguration(JSON.parse(additionalDetails)));
    }
    dispatch(updateInitialLoad(false));
  }
  resolve();
});

export const dispatchActionIfParentNotSelected = (optionId,
  choiceId,
  value,
  action = updateChoiceSuccess) => (dispatch, getState) => {
  const { configurator: { choices, options } } = getState();
  const option = options[optionId];
  const parentChoiceId = _get(option, 'parentChoiceId');
  const isSelected = _get(choices[parentChoiceId], 'isSelected');
  if (!isSelected && !isNaN(optionId) && !isNaN(choiceId)) {
    action(optionId, choiceId, value);
  }
};

export const dispatchActionHiddenUpdate = (optionId, choiceId, value, action = updateChoiceSuccess) => () => {
  action(optionId, choiceId, value);
};
